import React, { useCallback, useMemo, useState } from 'react'
import { Grid, Header, Loader } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector } from 'react-redux'
import { convertDateToUTCEpoch,convertDateToUTC } from "../../../Helper/date";
import { AddDropdown } from '../../../commonComponents/dropdown/AddDropdown'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import CopyRepElement from './copyRepElement'
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon'
import { getsearchcDropdownValuesUK } from '../../api/getGBForm'
import { useCurrentShipmentType } from '../../../hooks'

 const CertificateDetails=({isFormDisabled = false, saveItem,deleteItem,updateItem,copyData,item:{id,type,identification,part,statusCode,reason,issuingAuthority,docDate}})=>{

const {isImportShipment, isDisabled} = useCurrentShipmentType()
 const [description,setDescription] = useState('')
 const  documentStatusCode=useSelector((state) => state.DropDownValues.documentStatusCode)
 const box2387DocumentTypeDetails = useSelector((state) => state.DropDownValues.box2387DocumentTypeDetails)
 const box2387DocumentTypeIdentifier = useSelector((state) => state.DropDownValues.box2387DocumentTypeIdentifier)
 const box2387DocumentTypeReason = useSelector((state) => state.DropDownValues.box2387DocumentTypeReason)

 const detailesEntered = useMemo(()=>{
  return box2387DocumentTypeDetails?.find(c=>c.value==type)?.text
 },[box2387DocumentTypeDetails,type])



 const getDesCription =async() =>{
  if(description==''){
   try{
    let response = await getsearchcDropdownValuesUK("box2387DocumentType",type)
    console.log(response.data)
    if(response.data.eventMessage){
      setDescription(response.data.eventMessage?.box2387DocumentType?.[0]?.text)
    }
   }
  
catch{(err)=>console.log(err)}
 }}


  return (
  
            <Grid.Row>
              <Grid.Column width={1} style={{textAlign:'center'}}>                
                <CopyRepElement 
                  title={`DOCUMENTS/CERTIFICATES/AUTHORISATIONS`}
                  request={{type,identification,part,statusCode,reason,issuingAuthority,docDate}}
                  callback={copyData}
                  isFormDisabled={isDisabled}
                />
              </Grid.Column>
            <Grid.Column width={2} className='divFormFeild border-bottom b-rw-0'>
            <AddDropdown
            label="type"
            id={`certificateType-${id}`}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            shipmentType={isImportShipment?'IMPORT':'EXPORT'}
            // boxNumber='4/3'
            country='UK-CDS'
            type='box2387DocumentType'
            clearable
            onSelect={({ value }) => {
              let identification = ' '
              let reason = ' '
               if(value){
                 identification = box2387DocumentTypeIdentifier?.find(c=>c.value==value)?.text || '' 
                 reason = box2387DocumentTypeReason?.find(c=>c.value==value)?.text||''
               }
               setDescription('')
              updateItem(id,{type:value,identification,reason })
              saveItem({id,type:value,identification,reason})
            }}
            onBlur={({ value }) => {
              if(!value?.trim()){
                updateItem(id,{type:value})
                saveItem({id,type:value || " "})
              }
            }}
            selectedValue={type}
          />
       
              
              </Grid.Column>
              <Grid.Column width={2} className='divFormFeild border-bottom b-rw-0'>
             
          <InputField
            id={`identifier-${id}`}
            type="text"
            isLabel={false}
            disabled={isFormDisabled}
            className='field-bg'
            label="identifier"
            clearInput={false}
            value={identification}
            onChange={(value) =>updateItem(id,{identification:value})}
            onBlur={()=> saveItem({id,identification:identification || " "})}
          />
              </Grid.Column>
              <Grid.Column width={2} className='divFormFeild border-bottom b-rw-0'>
             
          <InputField
            id={`part-${id}`}
            type="text"
            isLabel={false}
            disabled={isFormDisabled}
            className='field-bg'
            label="part"
            clearInput={false}
            value={part}
            onChange={(value) =>{
              updateItem(id,{part:value})
             
            }}
            onBlur={()=>  saveItem({id,part:part || " "})}
          />
              </Grid.Column>
       
              <Grid.Column width={2} className='divFormFeild border-bottom  b-rw-0'>
              <DropDown
                id={`status-${id}`}
                className='field-bg dropdown100 addInfoCode'
                labelClass='text-none'
                isLabel={false}
                disabled={isFormDisabled}
                label="status code"
                data={documentStatusCode}
                value={statusCode}
                clearable
                onChange={(value) =>{
                  updateItem(id,{statusCode:value?.trim()})
                  saveItem({id,statusCode:value})
                }}
           />
              </Grid.Column>
              <Grid.Column
        width={2}
        className="divFormFeild border-bottom b-rw-0"
      >
        <InputField
          isLabel={false}
          disabled={isFormDisabled}
          id={`reason-${id}`}
          type="text"
          label="reason"
          className="field-bg"
          clearInput={false}
          value={reason}
          onChange={(value) =>updateItem(id,{reason:value})}
          onBlur={()=> saveItem({id,reason:reason || " "})}
        />
              </Grid.Column>
              <Grid.Column width={2} className='divFormFeild border-bottom b-rw-0'>
              <InputField
                isLabel={false}
                id={`authority-${id}`}
                type="text"
                label="issuing authority"
                disabled={isFormDisabled}
                className="field-bg"
                clearInput={false}
                value={issuingAuthority}
                onChange={(value) =>updateItem(id,{issuingAuthority:value})}
                onBlur={()=>saveItem({id,issuingAuthority:issuingAuthority || " "})}
          
        />
              </Grid.Column>
              <Grid.Column width={2} className="divFormFeild datePicker border-bottom">
                <InputField  
                id={`date-${id}`}
                name="date"
                type="date"
                label="date"
                disabled={isFormDisabled}
                className="field-bg"
                isLabel={false}
                clearInput={false}
                value={ convertDateToUTC(docDate)} 
                onChange={(value) => {
                  value=convertDateToUTCEpoch(value)
                  updateItem(id,{docDate:value})
                  saveItem({id,docDate:value})
                  }}
              />
          
        </Grid.Column>

        <Grid.Column width='1' className='icon-delete-add-info' style={type ? {display:"flex",alignItems:"center",justifyContent:"space-between"}: {display:"flex",justifyContent:"end"}} >
         {type && <PopUpIcon onMount={getDesCription} popupStyle={{maxWidth:'600px',minWidth:'100px'}} icon="info circle" style={{marginLeft:'12px'}}   popupText={
          <>
          <ul><li style={{marginBottom:'5px'}}><Header size='medium'>DESCRIPTION</Header></li><li><Header size='small'>{description!=''?description:<Loader active size='mini' />}</Header></li></ul>
          <ul style={{marginTop:'5px'}}><li style={{marginBottom:'5px'}}><Header size='medium'>DETAILS</Header></li><li><Header size='small'>{detailesEntered}</Header></li></ul>
          </>
        
          } />
        }
            
        <DeleteIcon id={`certificate-${id}`} onClick={() =>deleteItem(id)} disabled={isFormDisabled} />
      </Grid.Column>
            </Grid.Row>
            
     
  )
}

export default React.memo(CertificateDetails)